export default __webpack_public_path__ + "static/media/Logo2.0c530bb6.png";